package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.operation.get_cash_register_config.GetCashRegisterConfigModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.GetCashRegisterConfigRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ApaleoPropertieModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ApaleoPropertiesRepository

class ApaleoPropertiesRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): ApaleoPropertiesRepository {

    override suspend fun getApaleoProperties(): ApaleoPropertieModel
    {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                     query listApaleoProperties {
                       cashAssist {
                         listApaleoProperties {
                           id
                           name
                           __typename
                         }
                         __typename
                       }
                     } 
                """.trimIndent()
            )

            putJsonObject("variables") { }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )



        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception("Timeout or other error occurred")
        }

    }
}
